import type {
  IHttpCall,
  IHttpRequest,
  IHttpResponse,
} from '@hc-frontend/core-utils-net';
import { fetchBasedCall } from '@hc-frontend/core-utils-net';

import {
  AuditLeadHeadersDto,
  AuditLeadRequestDto,
  AuditLeadResponseDto,
} from './audit-lead.types';

type AuditLeadOptions = Partial<Omit<IHttpRequest<void>, 'body'>> & {
  httpCall?: IHttpCall;
  headers: AuditLeadHeadersDto;
};

export function auditLead(
  baseUrl: string,
  payload: AuditLeadRequestDto,
  options: AuditLeadOptions,
): Promise<IHttpResponse<AuditLeadResponseDto>> {
  const { httpCall = fetchBasedCall, headers, ...restOptions } = options;

  const request: IHttpRequest<AuditLeadRequestDto> = {
    url: `${baseUrl}/lead/audit`,
    method: 'POST',
    body: payload,
    headers,
    schemas: {
      request: AuditLeadRequestDto,
      response: AuditLeadResponseDto,
      headers: AuditLeadHeadersDto,
    },
    ...restOptions,
  };

  return httpCall(request);
}
